import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Link from "../../Link";
import { Flex, Icon, Text } from "@familyzone/component-library";
import NavItem from "./NavItem";
import AuthorizationWrapper from "../../../modules/AuthorizationWrapper";

const RootNavItem = ({ name, icon, dataCy, to, childItems, forceShowChildren, isActive, currentPath, remoteSupportAdmin }) => {
  const [isChildActive, setIsChildActive] = useState(false);

  useEffect(() => {
    setIsChildActive(window.location.pathname.startsWith(to));
  }, [currentPath, to]);

  const color = isChildActive || isActive ? "neutrals.900" : "neutrals.900";

  return (
    <Flex my="sp2" flexDirection="column" _first={{ mt: "sp4" }} _last={{ mb: "sp4" }}>
      <Link to={to} data-cy={dataCy}>
        <Flex
          alignItems="center"
          p="sp8"
          mx="sp8"
          mb="sp2"
          bg={isActive || isChildActive ? "#EDEDED" : "transparent"}
          _hover={{ bg: "#F1F5F9" }}
          borderRadius="xs"
        >
          <Icon boxSize="12px" icon={icon} color={"#68768B"} mr="sp8" />

          <Text fontSize="md" color={color} mr="auto">
            {name}
          </Text>
          {childItems && (isActive || isChildActive) && <Icon color={"#7D8CA1"} icon="fa-chevron-down" />}
          {childItems && !(isActive || isChildActive) && <Icon color={"#7D8CA1"} icon="fa-chevron-right" />}
        </Flex>
      </Link>
      {(isChildActive || isActive || forceShowChildren) && childItems && (
        <Flex ml="sp12" flexDirection="column">
          {childItems
            .filter((childItems) => !childItems.hidden)
            .filter((childItems) => !childItems.remoteSupportAdminOnly || remoteSupportAdmin)
            .map((childItem) => (
              <AuthorizationWrapper allowedRoles={childItem.allowedRoles} key={childItem.to}>
                <NavItem
                  to={childItem.to}
                  name={childItem.name}
                  childItems={childItem.childItems}
                  isNew={childItem.isNew}
                  remoteSupportAdmin={remoteSupportAdmin}
                />
              </AuthorizationWrapper>
            ))}
        </Flex>
      )}
    </Flex>
  );
};

RootNavItem.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  to: PropTypes.string,
  dataCy: PropTypes.string,
  childItems: PropTypes.arrayOf(PropTypes.object),
  forceShowChildren: PropTypes.bool,
  isActive: PropTypes.bool,
  currentPath: PropTypes.string,
  remoteSupportAdmin: PropTypes.bool,
};

export default RootNavItem;
